import { render } from "./VmsSidebarCamerasTabGroupDialogForm.vue?vue&type=template&id=2fe63b96&ts=true"
import script from "./VmsSidebarCamerasTabGroupDialogForm.vue?vue&type=script&lang=ts"
export * from "./VmsSidebarCamerasTabGroupDialogForm.vue?vue&type=script&lang=ts"

import "./VmsSidebarCamerasTabGroupDialogForm.vue?vue&type=style&index=0&id=2fe63b96&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__